import { Field, InputType, ObjectType } from 'type-graphql'
import { BaseEntity } from '../base/BaseEntity'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { RelatedEntity } from '../base/RelatedEntity'
import { User } from '../user/User'
import type { DocumentLockKeyEnum } from './DocumentLockKeyEnum'

@ObjectType()
@InputType('DocumentLockInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class DocumentLock extends BaseEntity {
  @Field(() => Date)
  @Prop({ type: Date })
  tokenExpiryDate: Date

  @Field(() => String)
  @Prop({ type: String })
  key: DocumentLockKeyEnum

  @Field(() => String)
  @Prop({ type: String })
  value: string

  @Field(() => User)
  @Prop({ type: RelatedEntity })
  user: User

  //this is for the resolver only
  @Field(() => Boolean)
  isLocked: boolean
}
